const faqs = [
  {
    q: '努努影院的电视剧真的全部免费吗？',
    a: '是的，努努影院所有电视剧内容均免费提供在线观看，无需付费、无需会员、无需注册登录。我们通过广告合作维持平台运营，用户可以无限制地畅享全站高清剧集。',
  },
  {
    q: '播放时会出现卡顿或缓冲吗？',
    a: '努努影院采用智能CDN加速和多线路切换技术，在正常网络环境下可确保流畅播放不缓冲。如遇卡顿，可尝试切换备用播放线路或降低画质档位。',
  },
  {
    q: '新剧集更新速度快吗？',
    a: '我们与各大内容源保持实时同步，热门剧集通常在播出后2小时内即可上线。每日更新剧集数量超过50部，确保追剧用户不错过任何精彩内容。',
  },
  {
    q: '支持哪些设备观看？',
    a: '努努影院全面适配PC端、平板和手机浏览器，无需下载任何插件。推荐使用Chrome、Safari等主流浏览器获得最佳高清播放体验，手机端还支持画中画播放。',
  },
  {
    q: '电视剧的画质怎么样？',
    a: '平台主推1080P全高清画质，部分热门剧集提供4K超清选项。用户可根据自身网络状况在播放器内自由切换标清、高清和超清三种画质档位。',
  },
  {
    q: '有没有地区限制？',
    a: '努努影院面向全球华人用户开放，无论你身处国内还是海外，都可以无障碍访问并免费在线观看。我们持续优化全球CDN节点，保障各地用户都能获得流畅观看体验。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          关于努努影院使用过程中最常见的疑问解答
        </p>
        <div className="max-w-[760px] mx-auto flex flex-col gap-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-background-50 border border-background-200 rounded-xl p-5 md:p-6">
              <h3 className="text-base font-bold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-primary-100 text-primary-600 rounded-full text-xs font-bold mt-0.5">
                  Q
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}